module.exports = __webpack_public_path__ + "media/call.fdf3fc40.mp3";